import { Link } from 'react-router-dom';
import { BackgroundImage } from '../../Layout/BackgroundImage';
import LoginForm from '../../Forms/LoginForm/LoginForm';
import * as React from 'react';
import { useEntrepreneurLoginPage } from './useEntrepreneurLoginPage';

export default function EntrepreneurLoginPage() {
  const scroller = useEntrepreneurLoginPage();
  return (
    <main className="container">
      <BackgroundImage url={'/img/main_landing-min.jpg'}>
        <div className="bg-success   bg-opacity-90  w-100 h-25">
          <div className="row justify-content-around pt-5 pb-5">
            <div className="col-10 pt-5 pb-5 row">
              <div className="col-9 pt-5">
                <h1 className="display-2 text-primary fw-bolder">Adriana Connect</h1>
                <h2 className="display-5 text-white fw-normal pb-3 text-break">
                  A céged minden banki tranzakciója egy helyen
                </h2>
                <ul className="text-white fs-5 list-unstyled">
                  <li className="fs-4 mb-1">
                    <i className="bi-people "></i>
                    <span className="mx-2">A pénzügyesed és a könyvelőd számára könnyen hozzáférhetően</span>
                  </li>
                  <li className="fs-4">
                    <i className="bi-shield-check mb-1"></i>
                    <span className="mx-2">Csak olvasási joggal, utalni nem tudnak vele</span>
                  </li>
                  <li className="fs-4">
                    <i className="bi-arrow-left-right mb-1"></i>
                    <span className="mx-2">Bekötheted az ERP rendszeredbe és a könyvelő programodba is</span>
                  </li>
                  <li className="fs-4">
                    <i className=" bi-currency-dollar mb-1"></i>
                    <span className="mx-2">Naprakész kintlévőség lista és várható bevételek előrejelzése</span>
                  </li>
                </ul>
                <a
                  href="#loginPanel"
                  className="btn rounded-0 box-shadow-btn bg-primary text-uppercase text-nowrap px-4 py-2 fs-5 text-white fw-bold"
                >
                  Érdekel
                </a>
              </div>
            </div>
          </div>
        </div>
      </BackgroundImage>
      <div className="row mt-5 justify-content-around align-items-center ">
        <div className="col-7 col-lg-7">
          <h3 className="text-primary h4 fw-bold pb-2">Az Adriana Connect szoftver célja</h3>
          <p>
            Időt spórolunk meg a cégvezetőknek, ügyvezetőknek és tulajdonosoknak azzal, hogy a banki utalásokat
            automatikusan elérhetővé tesszük a pénzügyes és a könyvelő számára. Így nem kell naponta, hetente vagy
            havonta belépni a netbankba, vagy küldözgetni az SMS kódokat.
          </p>
        </div>
        <div className="col-3 col-lg-3">
          <img
            className="box-shadow-right object-fit-cover "
            src="/img/purpose-min.jpg"
            width="220px"
            height="220px"
            style={{ maxWidth: '100%' }}
            alt="Az Adriana Connect szoftver célja"
          />
        </div>
      </div>
      <div className="row mt-5 justify-content-around align-items-center">
        <div className="col-3 ">
          <img
            className="box-shadow-left object-fit-cover"
            src="/img/how_it_works-min.jpg"
            width="220px"
            height="220px"
            alt="Hogyan működik?"
            style={{ maxWidth: '100%' }}
          />
        </div>
        <div className="col-7">
          <h3 className="text-primary h4 fw-bold pb-2">Hogyan működik?</h3>
          <p>
            Az ügyvezető egyszeri alkalommal beállítja a banki adatkapcsolatot az Adriana Connect szoftver számára. Ezt
            itt lent tudja elkezdeni, az email címének megadása az első lépés. A beállítási folyamat része az is, hogy
            az ügyvezető meghívja a pénzügyest vagy a könyvelőt. Az Adriana Connect szoftver minden nap automatikusan
            lekérdezi a banki tranzakciókat. A meghívott pénzügyes vagy könyvelő bármikor letöltheti az Adriana Connect
            szoftverből a cég bankszámla történetét.
          </p>
        </div>
      </div>
      <div id="loginPanel" ref={scroller} className="row mt-5">
        <div className="col bg-success text-white rounded-3 m-4 mb-0 justify-content-center text-center p-4">
          <h3>Az ügyvezető vagy?</h3>
          <p className="fs-6 mt-4 mx-4 mb-3 pb-0">
            A kezdéshez add meg az email címedet! Egy linket küldünk email-ben, arra kattintva tudsz belépni.
          </p>
          <LoginForm emailLabel="Ügyvezető email címe" />
        </div>
        <div className="col bg-success text-white rounded-3 m-4 mb-0 justify-content-center text-center p-4">
          <h3>A pénzügyes vagy a könyvelő vagy?</h3>
          <p className="h6 mt-4 ">Ha már meghívott ebbe a rendszerbe Téged az ügyvezető, akkor:</p>
          <Link
            className="btn rounded-0 box-shadow-btn bg-primary text-uppercase text-nowrap px-4 py-2 fs-5 text-white fw-bold"
            to="/login"
          >
            Belépés könyvelőként
          </Link>
          <p className="h6 mt-4 ">
            Ha még nem hívott meg ebbe a rendszerbe Téged az ügyvezető,
            <br />
            akkor küldd el neki ennek a weboldalnak a linkjét,
            <br />
            és kérd meg, hogy hívjon meg Téged!
          </p>
        </div>
      </div>

      <div className="row mt-5 justify-content-around align-items-center">
        <div className="col-7">
          <h3 className="text-primary h4 fw-bold pb-2">Melyik bankokkal kompatibilis?</h3>
          <div className="pb-2">
            Jelenleg az Adriana Connect szoftver az
            <a className="mx-1" href="https://aggreg8.io/users" target="_blank" rel="noreferrer">
              Aggreg8-en
            </a>
            keresztül és a Számlázz.hu
            <a
              className="mx-1"
              href="https://www.szamlazz.hu/egyedi-megoldasok/autokassza/"
              target="_blank"
              rel="noreferrer"
            >
              autokassza
            </a>
            funkcióján keresztül érhető el.
            <br />
            <h4 className="text-primary h5 fw-bold py-2">Aggreg8</h4>
            Ezekkel a bankokkal működik most az Aggreg8-en keresztül:{' '}
            <strong>
              CIB Bank, Gránit Bank, K&H Bank, MagNet Bank, MKB Bank, MKB Bank (korábban Budapest Bank), OTP Bank,
              Raiffeisen bank, Takarékbank, UniCredit Bank
            </strong>
            .<h4 className="text-primary h5 fw-bold py-2">Számlázz.hu autokassza</h4>
            Ezekkel a bankokkal működik most a Számlázz.hu autokassza funkcióján keresztül:
            <strong>
              {' '}
              CIB Bank, K&H Bank, MagNet Bank, MKB Bank, MKB Bank (korábban Budapest Bank), OTP Bank, Takarékbank,
              UniCredit Bank, Wise (korábban Transferwise)
            </strong>
            .
          </div>
          <p>
            Az Adriana Connect szoftver és a Számlázz.hu összekapcsolásához szükség van az autokasszára és az online
            könyvelői adatkapcsolatra is a Számlázz.hu-nál.
            <br />
            Az autokassza már a{' '}
            <a href="https://www.szamlazz.hu/digital-szolgaltatascsomag/" target="_blank" rel="noreferrer">
              #digital
            </a>{' '}
            csomagban is benne van, de az online könyvelői adatkapcsolat csak a{' '}
            <a href="https://www.szamlazz.hu/profi-szolgaltatascsomag/" target="_blank" rel="noreferrer">
              #profi
            </a>{' '}
            csomagban érhető el.
          </p>
          <h4 className="text-primary h5 fw-bold py-2">Fájl feltöltéssel</h4>
          <p>
            Tudjuk, hogy ez már a múlt, de amíg nincsen minden banknak működő API kapcsolata, addig fájl feltöltéssel is
            tudod használni 32 bankkal, sőt 30 csomag futárral és 18 bankkártya elfogadó rendszerrel is. Ezzel
            gyakorlatilag szinte minden magyar pénzügyi szolgáltatóval kompatibilis az Adriana Connect. Ezeknek a pontos
            listáját{' '}
            <a className="mx-1" href="https://automatik.hu/kompatibilitas/" target="_blank" rel="noreferrer">
              itt találod.
            </a>
          </p>
          <p>
            Már dolgozunk rajta, hogy még több bankkal kompatibilis legyen API-n keresztül is. Ha szeretnél értesülni
            róla, amikor bővül az API-val elérhető bankok listája, akkor írj egy emailt az adrianaconnect@automatik.hu
            címre!
          </p>
        </div>
        <div className="col-3">
          <img
            className="box-shadow-right object-fit-cover"
            src="/img/compatibility-min.jpg"
            width="220px"
            height="220px"
            alt="Melyik bankokkal kompatibilis?"
            style={{ maxWidth: '100%' }}
          />
        </div>
      </div>
      <div className="row mt-5 justify-content-around align-items-center mb-5">
        <div className="col-3">
          <img
            src="/img/robot.gif"
            width="220px"
            height="220px"
            alt="Ki fejleszti ezt a szoftvert?"
            style={{ maxWidth: '100%' }}
          />
        </div>
        <div className="col-7">
          <h3 className="text-primary h4 fw-bold py-2">Mennyibe kerül? (Árak)</h3>
          <p>Az első 30 nap ingyenes, bankkártya megadása nélkül. Az árakról a próbaidőszak alatt tájékoztatunk.</p>
          <h3 className="text-primary h4 fw-bold pb-2">Ki fejleszti ezt a szoftvert?</h3>
          <p>
            A könyvelői piacon közismert banki könyvelést automatizáló szoftver, az{' '}
            <a href="https://automatik.hu/" target="_blank" rel="noreferrer">
              Adriana Accounting
            </a>{' '}
            csapata készíti az Adriana Connect szoftvert is. Mindkét szoftver célja azonos az Adriana csapat céljával:
            Visszaadjuk a könyvelők szabadidejét!
          </p>
        </div>
      </div>
    </main>
  );
}
